import st from "@/styles/Ui.module.scss";
import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import {useEffect, useRef, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import {useTranslation} from "react-i18next";
import {country_code} from "@/utils/constants.ts";
import Button from "@/ui/Button.tsx";
import useAuth from "@/hooks/auth.ts";
import DashboardClass from "@/utils/dashboard_class.ts";


const CrApplyedDiffNumber = () => {
    
    const [open, setOpen] = useState(false)
    const effect_ran = useRef<boolean>(false)
    const {t} = useTranslation()
    const [initBody, setBody] = useState<any>({})
    const apply_credit_data = sessionStorage.getItem(CommonClass.local_storage_fields.apply_credit_form_body) || ""
    
    let data = apply_credit_data ? JSON.parse(apply_credit_data) : {}
    const auth = useAuth()
    
    const openModal = (x:boolean) => {
        setOpen(x)
    }
    
    useEffect(() => {
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.ModalEvents.CrApplyedDiffNumber, openModal)
            if (
                apply_credit_data &&
                typeof JSON.parse(apply_credit_data) === "object" &&
                Object.keys(JSON.parse(apply_credit_data)).length
            ) {
                setBody(JSON.parse(apply_credit_data))
            }
        }
        
        return () => {
            effect_ran.current = true
            
            if(!effect_ran.current) {
                eventEmitter.off(CommonClass.ModalEvents.CrApplyedDiffNumber, openModal)
            }
        }
    }, []);
    
    return auth.current_user() && (
        <ModalLayout
            className={st.cr_apply_diff_nr}
            open={open}
            innerClassName={st.cr_apply_diff_nr_inner}
            on_close_state={() => {
                sessionStorage.removeItem(CommonClass.local_storage_fields.apply_credit_form_body)
                setOpen(false)
            }}
        >
            
            <>
                <span>
                    {t("different_number")}
                    <strong>
                        {initBody.hasOwnProperty("phone") && country_code + initBody?.phone.replace(/\s/g, "")}?
                    </strong>
                </span>
                
                <div className={st.btn_container}>
                    <Button
                        onClick={() => {
                            localStorage.removeItem(CommonClass.local_storage_fields.have_logged_data)
                            auth.logOut()
                            sessionStorage.setItem(CommonClass.local_storage_fields.apply_credit_form_body, JSON.stringify(initBody))
                        }}
                    >
                        {t("continue_with")} {initBody.hasOwnProperty("phone") && country_code + initBody?.phone.replace(/\s/g, "")}
                    </Button>
                    
                    <Button
                        dark
                        onClick={()=>{
                            
                            const phone = auth.current_user()?.phone as string
                            data["phone"] = typeof auth.current_user()?.phone === "string" ? CommonClass.formatNumber(phone.replace(country_code, "")) : ""
                            
                            sessionStorage.setItem(CommonClass.local_storage_fields.apply_credit_form_body, JSON.stringify(data))
                            let timeout = setTimeout(() => {
                                eventEmitter.emit(CommonClass.CustomEvents.redirect_to, DashboardClass.dashboard_routes.ApplyCredit);
                                clearTimeout(timeout)
                            }, 1000)
                            setOpen(false)
                        }}
                    >
                        {t("continue_number")}
                    </Button>
                </div>
            </>
            
        </ModalLayout>
    )
}

export default CrApplyedDiffNumber